(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-start/assets/react/components/charity-container.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-start/assets/react/components/charity-container.js');

'use strict';

var _svs$lyckoplatsen$dat;
const CharityImg = svs.lyckoplatsen.components.page_start.react.components.CharityImg;
const activeCharitiesAtom = svs.lyckoplatsen.shared_charity.jotai.atoms.activeCharitiesAtom;
const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue;
const startPageVGHO = (_svs$lyckoplatsen$dat = svs.lyckoplatsen.data.cms) === null || _svs$lyckoplatsen$dat === void 0 ? void 0 : _svs$lyckoplatsen$dat.startPageVGHO;
const CmsTextFormatter = svs.lyckoplatsen.shared_utils.react.components.CmsTextFormatter;
const NO_CHARITY_TEXT = svs.lyckoplatsen.components.shared_constants.CONSTANTS.NO_CHARITY_TEXT;
const CharityContainer = () => {
  const activeCharities = useAtomValue(activeCharitiesAtom);
  if (!(activeCharities !== null && activeCharities !== void 0 && activeCharities.length)) {
    return React.createElement("div", {
      className: "lp-charity-container"
    }, React.createElement("div", {
      className: "lp-charity-body"
    }, React.createElement("h1", {
      className: "f-900 margin-right-2 margin-left-2"
    }, NO_CHARITY_TEXT.title), React.createElement("p", {
      className: "charity-description"
    }, NO_CHARITY_TEXT.description)));
  }
  return React.createElement("div", {
    className: "lp-charity-container"
  }, React.createElement("div", {
    className: "lp-charity-body"
  }, React.createElement("h1", {
    className: "f-900 margin-right-2 margin-left-2 ".concat(startPageVGHO === null || startPageVGHO === void 0 ? void 0 : startPageVGHO.color)
  }, startPageVGHO === null || startPageVGHO === void 0 ? void 0 : startPageVGHO.textTitle), React.createElement("p", {
    className: "charity-description ".concat(startPageVGHO === null || startPageVGHO === void 0 ? void 0 : startPageVGHO.color)
  }, React.createElement(CmsTextFormatter, {
    text: startPageVGHO === null || startPageVGHO === void 0 ? void 0 : startPageVGHO.textDescription
  })), React.createElement("div", {
    className: "lp-charity-imgs"
  }, activeCharities.map(c => React.createElement(CharityImg, {
    charityProps: c,
    key: c.charityId
  })))));
};
setGlobal('svs.lyckoplatsen.components.page_start.react.components', {
  CharityContainer
});

 })(window);